module.exports = __webpack_public_path__ + "static/media/reservation-white.2b9dd35d.svg";